import React from 'react';
import Radium from 'radium';
import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';
import {Helmet} from "react-helmet";
import NoticeBanner from 'views/NoticeBanner';

function SetoCanvasPage({title, metaDescription, id, children, preContainerComp, postContainerComp, noticeMessage, turnOffSticky}) {
    return (<div id={id}>
					<Helmet>
						<title>{title || "Seto Canvas"}</title>
                        {
                            metaDescription && 
                            <meta name="description" content={metaDescription} />
                        }
    					
					</Helmet>
					{noticeMessage &&
						<NoticeBanner>
							{noticeMessage}
						</NoticeBanner>
					}

			        <HeaderContainer turnOffSticky={turnOffSticky} />

					{preContainerComp}

			        <div className="mainContainer">
			        	{children}
			        </div>

					{postContainerComp}
			        <Footer />
		      	</div>
		);
} 

export default Radium(SetoCanvasPage);


// WEBPACK FOOTER //
// ./src/pages/SetoCanvasPage.js